import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import inseminatorListAction from './inseminatorList.action.json' with { type: 'json' }
import { inseminatorObject } from '../inseminatorObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'

export const inseminatorExpression = expression(inseminatorObject.shape)

const inseminatorListDefinition = defineAction({
  ...inseminatorListAction,

  input: z.object({
    filter: inseminatorExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      code: 'Código',
      fullName: 'Nome',
      cpf: 'CPF',
      citizenId: 'Cidadão',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeInactivated: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(inseminatorObject.extend({ citizen: citizenObject })),
    count: z.number(),
  }),
})

export default inseminatorListDefinition
